// const constants = {
//   ADDON: {
//     DVP: 'DVP',
//     PMV: 'PMV',
//     VVE: 'VVE',
//   },
//   BLACKFRIDAY: {
//     APPLE: 'Apple Black Friday Deals',
//     BEAUTY: 'Beauty Black Friday Deals',
//     BED: 'Beds & Mattresses Black Friday Deals',
//     CHRISTMAS: 'Christmas Black Friday Deals',
//     FASHION: 'Fashion Black Friday Deals',
//     HOME: 'Home Black Friday Deals',
//     JEWELLERY: 'Jewellery Black Friday Deals',
//     KIDS: 'Kids Black Friday Deals',
//     LAPTOP: 'Laptop Black Friday Deals',
//     LOCAL: 'Local Black Friday Deals',
//     SAMSUNG: 'Samsung Black Friday',
//     TECH: 'All Black Friday Tech Deals',

//     VIEW_ALL_DEALS: 'View All Black Friday Deals',

//     WATCHES: 'Watches Black Friday Deals',
//   },
//   DEAL_TYPES: {
//     CHANNELMANAGER: 'channelManager',
//     DEFAULT: 'default',
//   },
//   // LAYOUT_TYPES: {
//   //   claimTwoByTwo: 'claim-2x2',
//   //   grid: 'grid',
//   //   twoByTwo: '2x2',
//   // },
//   PAGE_TYPES: {
//     ACCOUNT: 'account',
//     CATEGORY: 'category',
//     CHECKOUT: 'checkout',
//     CLAIM_EXPERIENCE_GIFT: 'claim-gift',
//     DASHBOARD: 'dashboard',
//     DEAL: 'deal',
//     DEAL_PREVIEW: 'dealPreview',
//     EARLY_BIRD: 'early-bird',
//     EXTEND_LANDING: 'extendLanding',
//     GIFT_FINDER: 'gift-finder',
//     GIFTS: 'gifts',
//     GUIDE: 'guide',
//     HOMEPAGE: 'homepage',
//     MAP_VIEW: 'map-view',
//     OTHER: 'other',
//     PPC: 'ppc',
//     RECENTLY_VIEWED: 'recentlyViewed',
//     RECOMMENDED: 'recommended',
//     ROOT: 'root',
//     SEARCH: 'search',
//     SPECIAL: 'special',
//     TRAVEL: 'travel',
//     VIP_CATEGORY: 'vipCategory',
//     VIP_DEAL: 'vipDeal',
//     VOUCHERS: 'vouchers',
//     WELLNESS_COLLECTION: 'wellness-collection',
//   },
//   PAYMENT: {
//     CARD_LENGTH: 16,
//     CVV_LENGTH: 3,
//     MONTH_DEFAULT_VALUE: '00',
//     PAYMENT_BUTTON_TRACKING_TYPES: {
//       APPLE: 'choose_apple',
//       CARD: 'choose_card',
//       CLEARPAY: 'choose_clearpay',
//       GOOGLE: 'choose_google',
//       KLARNA: 'choose_klarna',
//       PAYPAL: 'choose_paypal',
//     },
//     PAYMENT_DOD_TRACKING_CARD_STATUS: {
//       EXISTING: 'EXISTING',
//       NEW: 'NEW',
//     },
//     PAYMENT_DOD_TRACKING_GATEWAY: {
//       BRAINTREE: 'BRAINTREE',
//       CLEARPAY: 'CLEARPAY',
//       KLARNA: 'KLARNA',
//     },

//     PAYMENT_DOD_TRACKING_TYPES: {
//       APPLE: 'Apple Pay',
//       CARD: 'Card',
//       CLEARPAY: 'Clearpay',
//       GOOGLE: 'Google Pay',
//       KLARNA: 'Klarna',
//       PAYPAL: 'PayPal',
//     },
//     PAYMENT_METHODS: {
//       APPLE: 'ApplePay',
//       CARD: 'Card',
//       CLEARPAY: 'Clearpay',
//       GOOGLE: 'GooglePay',
//       KLARNA: 'Klarna',
//       PAYPAL: 'PayPal',
//       PAYPAL_CREDIT: 'PayPal Credit',
//     },
//     PAYMENT_TYPES: {
//       APPLE: 'apple_pay',
//       CARD: 'credit_card',
//       CLEARPAY: 'clearpay',
//       GOOGLE: 'google_pay',
//       KLARNA: 'klarna',
//       PAYPAL: 'paypal',
//     },
//     YEAR_DEFAULT_VALUE: '00',
//   },
//   POST_CHECKOUT_SOURCE: 'my_wowcher',
//   REFER_A_FRIEND: {},

//   SECOND_CHECKOUT_SOURCE: 'second_checkout',
//   SHOW_PRICE_TYPES: {
//     HIDDEN: 'PRICE_IS_HIDDEN',
//     SHOW_DISCOUNT_INDICATIVE: 'SHOW_DISCOUNT_INDICATIVE',
//     SHOW_DISCOUNTS: 'SHOW_DISCOUNT',
//     SHOW_ORIGINAL_PRICE: 'SHOW_ORIGINAL_PRICE',
//     SHOW_PRICE: 'SHOW_PRICE',
//     SHOW_VIP_DISCOUNT_PRICE: 'SHOW_VIP_DISCOUNT_PRICE',
//   },
//   TYPE_CATEGORY_DEALS: 'CATEGORY_DEALS',
//   TYPE_CATEGORY_DEAL: 'CATEGORY_DEAL',
//   VIP_LAYOUT_TYPE: {
//     CHECKBOX: 'CHECKBOX',
//     SHOW_NO_VIP: 'SHOW_NO_VIP',
//     TWO_BUTTONS: 'TWO_BUTTONS',
//   },
//   // VIP_QUALIFIERS: ['vipCategory', 'vipDeal'],
//   DEALS_COMPONENT: {
//     MOST_POPULAR: 'Most Popular',
//   },
// };

// export default constants;

// COOKIES CONFIG
export const COOKIES = {
  abAutocomplete: 'addr-auto-test',
  abBookingCalendarOnRedemptionGift: 'bc-gifting-test',
  affiliate: 'dod-affiliate',
  affiliateUser: 'dod-affiliate-returned',
  apiAuthToken: 'apiAuthToken',
  awin_event: 'awin_event',
  awinSource: 'dod-awin-source',
  basketToken: 'bt',
  brandCookie: '5pm-win',
  brandswapTest: 'brandswap-test',
  buyDeal: 'dod-buy-deal',
  cjevent: 'cjevent',
  confirmEmailRequired: 'cer',
  core: 'coreCookie',
  ctoBundle: 'cto_bundle',
  customerToken: 'ct',
  deleteEmail: 'delete-email',
  didomi_token: 'didomi_token',
  dynamicPrice: 'dp',
  emailOptOut: 'emailoptout',
  euconsent: 'euconsent',
  euconsent_v2: 'euconsent-v2',
  freshRel: 'freshRel',
  gclid: 'dod-gclid',
  giftPackDeliveryTest: 'ndd-test',
  giftPackPrice: 'gpdpi',
  googleLocation: 'google-location',
  googleOneTap: 'google-one-tap',
  googleTimer: 'google-timer',
  hasPassword: 'hp',
  historicPurchaseSource: 'dod-historic-purchase-source',
  landingPage: 'landing_page2',
  lbSessionSkip: 'dod-subscribe-modal-session-skip',
  lightbox: 'subscribeLightbox',
  lightboxClosed: 'offline_lightbox-closed',
  lightboxLocation: 'lightbox-location',
  lightboxVip: 'lightbox_vip',
  lightPage: 'lightPage',
  location: 'dod-location',
  loginSourcePageType: 'login-source',
  loginType: 'login-type',
  logoutURL: 'dod-post-logout-url',
  lsIELightBox: 'lsiegslb',
  mapBackPath: 'map-back',
  mapViewTest: 'map-view-test',
  mgid: 'mgid',
  msclkid: 'dod-msclkid',
  oldDidomiCookieRemoved: 'old_didomi_cookie_removed',
  onSiteV3: 'onSiteV3',
  optAlertBox: 'OptanonAlertBoxClosed',
  optConsent: 'OptanonConsent',
  pagination: 'pagination',
  passwordlessCheckoutTest: 'pwTest',
  passwordResetToken: 'password_reset_token',
  paypalBilling: 'ppbt',
  postLoginUrl: 'dod-post-login-url',
  profile_image_url: 'dod-user-profile-image-url',
  purchaseUrl: 'dod-purchase-url',
  recentDeals: 'recentDeals',
  redirectLocal: 'dod-redirect-local',
  redirectUrl: 'dod-redirect',
  referralCode: 'referral-code',
  referralRegistered: 'referral-registered',
  registered: 'dod-registered',
  reviewsTest: 'reviews-test',
  sailthruDP: 'dp_st_data_sent',
  sessionId: 'sessionId',
  sessionITOSource: 'dod-ito-source',
  sessionSource: 'dod-session-source',
  showConfirmation: 'show-confirmation',
  smartbannerClosed: 'smartbannerClosed',
  splunkGuid: 'splunkGuid',
  subscribed: 'subscribed',
  subscriptionModal: `5pm-subscription-win`,
  tmsID: 'tms_VisitorID',
  unboxedSearchTest: 'unbxd-test',
  userEmail: 'dod-user-email',
  userInfo: 'dod-user-info',
  userLoggedIn: 'dod_logged_in',
  userProfile: 'user_profile',
  userSource: 'dod-user-source',
  v5_ab: 'v5_ab',
  validSubscription: 'valid-subscription',
  videoRolloutTest: 'videoRollout',
  vipChecked: 'vip_checked',
  vipHub: 'viphub',
  visitorId: 'visitor_id',
  vveTestLanding: 'vve-test-landing',
  wishlistId: 'wishlistId',
  wowcherUser: 'wowcher_user',
};

// 42 cookies

export const SYMBOL = '£';
export const CURRENCY_SYMBOL = '£';
export const CURRENCY_CODE = 'GBP';
export const WALLET_GBP_INDEX = 0;
export const WALLET_EUR_INDEX = 1;
export const WALLET_PRIMARY_CURRENCY_INDEX = WALLET_GBP_INDEX;

// Login and registration setup
export const POST_CODE_MAX_LENGTH = 8;
export const PASSWORD_MIN_LENGTH = 6;

export const SIGN_IN_WITH_GOOGLE = `signin_with`;
export const SIGN_UP_WITH_GOOGLE = `signup_with`;
export const SIGN_IN_WITH_FACEBOOK = 'Sign in with Facebook';

// form types
export const TYPE_PAYMENT = 'TYPE_PAYMENT';
export const TYPE_PAYMENT_UNDERLINED = 'TYPE_PAYMENT_UNDERLINED';
export const TYPE_UNDERLINED = 'TYPE_UNDERLINED';

// Location Constants
export const DEFAULT_LOCATION = {
  _score: Number.NaN,
  brand: 'wowcher',
  countryCode: 'gb',
  id: 275_850,
  latLon: {
    lat: 51.5,
    lon: -0.116_667_002_439_498_9,
  },
  name: 'London',
  shortName: 'london',
};
export const LOCATION_SELECTED = 'location-selected';

export const SCROLL_CONSTANTS = {
  AMENITIE_COMPONENT: 'amenitiesComponent',
  CHOOSE_YOUR_OPTIONS_ACTIONS: 'ChooseYourOptionsActions',
  CHOOSE_YOUR_OPTIONS_COMPONENT: 'ChooseYourOptions',
  CHOOSE_YOURS_OPTIONS_DEAL: 'choose-your-options-deal',
  DROPDOWN_PRODUCT_PAGE: 'dropdownProductPage',
  REVIEWS_COMPONENT: 'reviewsComponent',
  SCROLL_INLINE_CALENDAR: 'scroll-inline-calendar',
  SCROLL_TO_MAP_LOCATION: 'scroll-to-map-location',
};

export const DEAL_ORDER = {
  even: 'EVEN',
  odd: 'ODD',
};

export const VIP_QUALIFIERS_PAGE_TYPE = ['vipCategory', 'vipDeal'];

export const PAGE_TYPES = {
  ACCOUNT: 'account',
  CATEGORY: 'category',
  CHECKOUT: 'checkout',
  CLAIM_EXPERIENCE_GIFT: 'claim-gift',
  DASHBOARD: 'dashboard',
  DEAL: 'deal',
  DEAL_PREVIEW: 'dealPreview',
  EARLY_BIRD: 'early-bird',
  EXTEND_LANDING: 'extendLanding',
  GIFT_FINDER: 'gift-finder',
  GIFTS: 'gifts',
  GUIDE: 'guide',
  HOMEPAGE: 'homepage',
  MAP_VIEW: 'map-view',
  OTHER: 'other',
  PPC: 'ppc',
  RECENTLY_VIEWED: 'recentlyViewed',
  RECOMMENDED: 'recommended',
  ROOT: 'root',
  SEARCH: 'search',
  SPECIAL: 'special',
  TRAVEL: 'travel',
  VIP_CATEGORY: 'vipCategory',
  VIP_DEAL: 'vipDeal',
  VOUCHERS: 'vouchers',
  WELLNESS_COLLECTION: 'wellness-collection',
};

// QUALIFIERS
export const QUALIFIERS = {
  TRAVEL_DEAL: ['travel', 'escapes'],
};

export const DEAL_LAYOUT_TYPES = {
  CLAIM_TWO_BY_TWO: 'claim-2x2',
  GRID: 'grid',
  TWO_BY_TWO: '2x2',
};

export const LAYOUT_TYPES = {
  ACCOUNT_LAYOUT: 'AccountLayout',
  CHECK_OUT_LAYOUT: 'CheckoutLayout',
  DEALS_LAYOUT: 'DealsLayout',
  DELETE_LAYOUT: 'DeleteLayout',
  GIFT_LAYOUT: 'GiftLayout',
  HEADER_FOOTER_LAYOUT: 'HeaderFooterLayout',
  LOGIN_LAYOUT: 'LoginLayout',
  VIP_LAYOUT_TYPE: {
    CHECKBOX: 'CHECKBOX',
    SHOW_NO_VIP: 'SHOW_NO_VIP',
    TWO_BUTTONS: 'TWO_BUTTONS',
  },
};
export const GIFTING_OPTIONS = {
  // ls only: this sets product.gift = true only.
  E_GIFT: 'e-gift',
  // GIFT: 'gift',
  // // NON-DELIVERABLE wowcher only: does not exist on ls
  // GIFT_PACK: 'gift-pack',

  // // for next day delivery gift pack
  NEXT_DAY_GIFT_PACK: 'ndd-gpk',

  NONE: 'none',
  // // for standard delivery gift pack
  // STANDARD_DELIVERY_GIFT_PACK: 'std-gpk',
  // WRAPPED: 'wrapped', // DELIVERABLE wowcher only: does not exist on ls
};

// BUY AGAIN
export const BUY_AGAIN_DEALS_FLAG = 'BUY_AGAIN_DEALS_FLAG';

export const DEAL_LOCATION_TYPES = {
  local: 'local',
  national: 'national',
};

export const PAGE_QUERY = {
  claimMyGift: 'isClaimMyGift',
};
export const DEAL_PAGE_PATH_QUALIFIERS = ['deal', 'email-deal', 'email-deals'];
export const CATEGORY_PAGE_PATH_QUALIFIERS = ['deals', 'near-me'];
export const TRAVEL_DEAL_QUALIFIERS = ['travel', 'escapes'];
export const NATIONAL_DEAL_QUALIFIERS = ['shop', 'national-deal'];

// Navigations Layout
export const NAVIGATION_LAYOUT = {
  fourGridNav: ['Home'],
  groupedCatgory: [
    // 'Gifts',
    // 'Home',
    // 'Garden',
    'Spa Days',
  ],
  highlightedCat: ['Home DIY', 'Laundry', 'Small Bedroom Ideas', 'Stationary'],
  nationalCategory: [
    'home',
    'garden',
    'electricals',
    'personalised-gifts',
    /* 'gifts', */
    'black-friday',
    'beauty-products-equipment',
    'fitness-leisure-camping',
    'menswear',
    'luggage-travel',
    'christmas',
    'drinking',
    'mystery-deals-competitions',
    'fashion',
    'fashion-jewellery',
    'jewellery',
    'home-garden',
    'home-essentials',
    'kids',
    'adult',
    'pets',
    'hobbies-leisure',
  ],
};

// Subscriber
export const SUBSCRIBER_TEST_IDS = {
  CLOSE_BUTTON: 'close-button',
  EMAIL_INPUT: 'email-input',
  ERROR_TEXT: 'error-text',
  GOOGLE_BUTTON: 'google-button',
  LOCATION_SELECT: 'location-select',
  LOGIN_BUTTON: 'login-button',
  SUBMIT_BUTTON: 'submit-button',
  SUBTITLE_TEXT: 'subtitle-text',
};

export const LIGHTBOX_APPEARED = 'lightbox-appeared';
export const EMAIL_INPUT_SCROLL_TO_ID = 'emailInputScrollToId';

export const BLACK_FRIDAY_DEALS_TYPE = {
  APPLE: 'Apple Black Friday Deals',
  BEAUTY: 'Beauty Black Friday Deals',
  BED: 'Beds & Mattresses Black Friday Deals',
  CHRISTMAS: 'Christmas Black Friday Deals',
  FASHION: 'Fashion Black Friday Deals',
  HOME: 'Home Black Friday Deals',
  JEWELLERY: 'Jewellery Black Friday Deals',
  KIDS: 'Kids Black Friday Deals',
  LAPTOP: 'Laptop Black Friday Deals',
  LOCAL: 'Local Black Friday Deals',
  SAMSUNG: 'Samsung Black Friday',
  TECH: 'All Black Friday Tech Deals',
  VIEW_ALL_DEALS: 'View All Black Friday Deals',
  WATCHES: 'Watches Black Friday Deals',
};

export const DEAL_COMPONENT = {
  MOST_POPULAR: 'Most Popular',
};

export const DEAL_TYPES = {
  CHANNELMANAGER: 'channelManager',
  DEFAULT: 'default',
};

export const TYPE_CATEGORY_DEALS = 'CATEGORY_DEALS';

export const TYPE_CATEGORY_DEAL = 'CATEGORY_DEAL';

export const CLICK_AND_COLLECT = 'Click and Collect';
export const CLICK_AMP_COLLECT = 'Click & Collect';
// Calendar
export const CALENDAR_STEP_TWO = 'calendarStepTwo';

// BCOR
export const BCOR_STEP_ONE_EL = 'bcorStepOne';

export const MODALS = {
  dealAvailability: 'deal-availability-modal',
  default: 'wowModal',
  lightbox: 'lightbox-modal',
};

// Filters values
export const FILTERS_CONFIG = {
  FILTER_ALL: 'all',
  FILTER_CATEGORY: 'category',
  // Maps Filters
  FILTER_CATEGORY_MAPS: 'categories',
  FILTER_LOCATION: 'location',
  FILTER_MAXPRICE: 'maxPrice',
  FILTER_MINPRICE: 'minPrice',
  FILTER_NEW: [
    {
      name: 'New',
      value: '0',
    },
  ],
  FILTER_ORDER: 'order',
  // possible values: POPULARITY, DATE, PRICE, POSITION, DISCOUNTPERCENTAGE, RECENTLYADDED, DISTANCE
  FILTER_POPULARITY: [
    {
      name: 'Popularity',
      value: 'popularity',
    },
    {
      name: 'Price high to low',
      value: 'price',
    },
    /*
  {
    name: 'Date',
    value: 'date',
  },
  */
    {
      name: 'Discount %',
      value: 'discountPercentage',
    },
    {
      name: 'Recently Added',
      value: 'recentlyAdded',
    },
    {
      name: 'Price low to high',
      value: 'pricelow',
    },
  ],
  FILTER_PRICE: [
    {
      name: '0',
      value: '0',
    },
    {
      name: '10',
      value: '10',
    },
    {
      name: '20',
      value: '20',
    },
    {
      name: '50',
      value: '50',
    },
    {
      name: '100',
      value: '100',
    },
    {
      name: '1000',
      value: '1000',
    },
  ],
  FILTER_PRICE_TRAVEL: [
    {
      name: '0',
      value: '0',
    },
    {
      name: '50',
      value: '50',
    },
    {
      name: '100',
      value: '100',
    },
    {
      name: '150',
      value: '150',
    },
    {
      name: '200',
      value: '200',
    },
    {
      name: '300',
      value: '300',
    },
    {
      name: '400',
      value: '400',
    },
    {
      name: '500',
      value: '500',
    },
    {
      name: '750',
      value: '750',
    },
    {
      name: '1000',
      value: '1000',
    },
  ],
  FILTER_RATING: [
    {
      name: 'Rating',
      value: '0',
    },
  ],
  FILTER_SORTBY: 'orderBy',
  FILTER_SUBCATEGORY: 'subcategory',

  FILTER_TAG: 'searchTag',
  FILTER_VIP: 'vip',
};

// MAP VIEW
export const MAP_VIEW = {
  ALL_CATEGORY_FILTERS: [
    {
      name: 'Activities',
      shortName: 'activities',
      value: 'activities',
    },
    {
      name: 'Beauty',
      shortName: 'beauty',
      value: 'beauty',
    },
    {
      name: 'Entertainment',
      shortName: 'entertainment',
      value: 'entertainment',
    },
    {
      name: 'Food and Drink',
      shortName: 'drinking',
      value: 'drinking',
    },
    {
      name: 'Healthcare',
      shortName: 'healthcare',
      value: 'healthcare',
    },
    {
      name: 'Restaurants & Bars',
      shortName: 'restaurantandfood',
      value: 'restaurantandfood',
    },
    {
      name: 'Spas & Country House',
      shortName: 'spascountryhouse',
      value: 'spascountryhouse',
    },
    {
      name: 'Sports & Adventure',
      shortName: 'sportsadventure',
      value: 'sportsadventure',
    },
    {
      name: 'UK City Breaks',
      shortName: 'ukcitybreaks',
      value: 'ukcitybreaks',
    },
    {
      name: 'UK Seaside',
      shortName: 'ukseaside',
      value: 'ukseaside',
    },
  ],
  FILTER_PRICE_MAPS: [
    {
      name: '0',
      value: '0',
    },
    {
      name: '10',
      value: '10',
    },
    {
      name: '20',
      value: '20',
    },
    {
      name: '50',
      value: '50',
    },
    {
      name: '100',
      value: '100',
    },
    {
      name: '200',
      value: '200',
    },
  ],
  MAP_API_ERROR_TEXT: 'Sorry there was a problem',
};

export const PAYMENT_TYPES = {
  apple: 'apple_pay',
  card: 'credit_card',
  clearpay: 'clearpay',
  google: 'google_pay',
  klarna: 'klarna',
  paypal: 'paypal',
};

export const PAYMENT_METHODS = {
  applePay: 'ApplePay',
  card: 'Card',
  clearpay: 'Clearpay',
  googlePay: 'GooglePay',
  klarna: 'Klarna',
  paypal: 'PayPal',
  payPalCredit: 'PayPal Credit',
};

export const PAYMENT_BUTTON_TRACKING_TYPES = {
  apple: 'choose_apple',
  card: 'choose_card',
  clearpay: 'choose_clearpay',
  google: 'choose_google',
  klarna: 'choose_klarna',
  paypal: 'choose_paypal',
};

export const PAYMENT_DOD_TRACKING_TYPES = {
  apple: 'Apple Pay',
  card: 'Card',
  clearpay: 'Clearpay',
  google: 'Google Pay',
  klarna: 'Klarna',
  paypal: 'PayPal',
};

export const PAYMENT_DOD_TRACKING_CARD_STATUS = {
  existing: 'EXISTING',
  new: 'NEW',
};

export const PAYMENT_DOD_TRACKING_GATEWAY = {
  braintree: 'BRAINTREE',
  clearpay: 'CLEARPAY',
  klarna: 'KLARNA',
};

export const CARD_LENGTH = 16;
export const CVV_LENGTH = 3;

export const MONTH_DEFAULT_VALUE = '00';
export const YEAR_DEFAULT_VALUE = '00';
export const PAYMENT_TOP_CTA_ID = 'top-cta-button';
export const FIND_FEED_PAGE_SIZE = 20;
const environment = process.env.NEXT_PUBLIC_ENVIRONMENTNO || 'dev09';

const environmentNo = environment.replace(/\D/g, '');
export const IMAGES_DEAL_URL = {
  dev: `https://images${environmentNo}.devwowcher.co.uk`,
  nxt: 'https://images01.nxtwowcher.co.uk',
  prod: 'https://images.wowcher.co.uk',
};

export const STATIC_IMAGES_URL = {
  dev: `https://static.wowcher.co.uk`,
  nxt: `https://staticnxt01.wowcher.co.uk`,
  prod: `https://static.wowcher.co.uk`,
};

export const REDEEM_IMAGE_TYPES = {
  calendar: 'calendar',
  callToBook: 'call-to-book',
  chooseYourFlight: 'choose-your-flight',
  mysteryTravel: 'mystery-travel',
  standard: 'standard',
  standardTravel: 'standard-travel',
};

export const TRAVEL_API_PATH_NAME = 'travel';
export const TRAVEL_FE_PATH_NAME = 'travel'; // for living social uk and ie -- its value is escapes
export const COUNTRY_PATH_NAME = 'scotland';

// Voucher Item Gifting
export const VOUCHER_ITEM_KEY = {
  DEFAULT_EVENT_KEY: 'closed',
  GIFTING_EVENT_KEY: 'gifting',
  HELP_EVENT_KEY: 'help',
  PROGRESS_EVENT_KEY: 'progress',
  REDEEM_EVENT_KEY: 'redeem',
  RETURN_EVENT_KEY: 'return',
};
export const BRAINTREE = 'bt';
export const AWINCHANNEL = 'aw';

export const ADDON_DVP = 'DVP';
export const ADDON_EXTENSION = 'VVE';
export const ADDON_PMV = 'PMV';

export const SECOND_CHECKOUT_SOURCE = 'second_checkout';
export const POST_CHECKOUT_SOURCE = 'my_wowcher';

// VIP Subscribe helper
export const STATUS_ELIGIBLE = 'ELIGIBLE';
export const STATUS_NOT_ELIGIBLE = 'NOT_ELIGIBLE';
export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_RENEW = 'RENEW';
export const NOT_CHECKED = 'NOT_CHECKED';

export const USER_STATUS_MAPPING = {
  a: 'hasAddress',
  d: 'DED',
  f: 'isFacebook',
  fo: 'FBO',
  hp: 'hasPassword',
  l: 'isLocked',
  r: 'isRegistered',
  s: 'isSubscribed',
  tpl: 'tpl', // third party login
};

// google hotel ads

export const HOTEL_URL_PARAMS = {
  arrival: 'arrival',
  departure: 'departure',
  guests: 'guests',
  product_id: 'productId',
  utm_medium: 'utm_medium',
  utm_source: 'utm_source',
};

export const HOTEL_URL_VALUES = {
  utm_medium_free: 'free-hotel-ads',
  utm_medium_paid: 'paid-hotel-ads',
  utm_source_google: 'google',
};

export const HOTEL_API_PARAMS = {
  checkIn: 'checkIn',
  checkOut: 'checkOut',
  guests: 'guests',
  product_id: 'leadInProductId',
  utm_medium: 'utmMedium',
  utm_source: 'utmSource',
};

export const HOTEL_API_VALUES = {
  utm_medium_free: 'free',
  utm_medium_paid: 'paid',
  utm_source_google: 'google',
};

export const URLSTATICSUFFIX = '.html';

export const RECENT_DEALS_LOCAL_STORE = `angular5pm.recentDealsLocalStore`; // recent deals storage key

// Maps Filters
export const FILTER_CATEGORY_MAPS = 'categories';

// device
export const WEBAPP_MOBILE = 'WEBAPP-MOBILE';
export const WEBAPP_TABLET = 'WEBAPP-TABLET';
export const WEBAPP_DESKTOP = 'WEBAPP-DESKTOP';

// Payment
export const PAYMENT_ELEMENT_NAME = 'payment-component-element';

// Filters values
export const FILTER_LOCATION = 'location';
export const FILTER_SUBCATEGORY = 'subcategory';
export const FILTER_CATEGORY = 'category';
export const FILTER_TAG = 'searchTag';
export const FILTER_ORDER = 'order';
export const FILTER_SORTBY = 'orderBy';
export const FILTER_MINPRICE = 'minPrice';
export const FILTER_MAXPRICE = 'maxPrice';
export const FILTER_VIP = 'vip';
export const FILTER_ALL = 'all';

// VIP
export const VIP = 'VIP';

export const SHOW_PRICE_TYPES = {
  hidden: 'PRICE_IS_HIDDEN',
  showDiscount: 'SHOW_DISCOUNT',
  showDiscountIndicative: 'SHOW_DISCOUNT_INDICATIVE',
  showOriginalPrice: 'SHOW_ORIGINAL_PRICE',
  showPrice: 'SHOW_PRICE',
  showVipDiscountPrice: 'SHOW_VIP_DISCOUNT_PRICE',
};

export const DEAL_CATEGORY_LOCATIONS = {
  shop: 'shop',
};

export const APP_BANNER_APPLE = 'Apple';
export const APP_BANNER_GOOGLE = 'Google';

/* eslint-disable filenames/match-regex */
// ACTION TYPES REDUX

export const USER = {
  RESET_USER: 'RESET_USER',
  SET_AUTH_CHECK_FINISHED: 'SET_AUTH_CHECK_FINISHED',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  SET_BASKET_TOTAL: 'SET_BASKET_TOTAL',
  SET_LIGHTBOX: 'SET_LIGHTBOX',
  SET_USER: 'SET_USER',
};

export const USER_EMAIL = { SET_USER_EMAIL: 'SET_USER_EMAIL' };

export const LOADING_STATE = {
  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
};

export const LOCATIONS = {
  GET_LOCATIONS: 'GET_LOCATIONS',
  SET_LOCATION: 'SET_LOCATION',
  SET_LOCATIONS: 'SET_LOCATIONS',
};

export const MERCHANT = {
  SET_MERCHANT: 'SET_MERCHANT',
};

export const TILES = {
  GET_TILES: 'GET_TILES',
  SET_TILES: 'SET_TILES',
};

export const DEALS = {
  GET_DEALS: 'GET_DEALS',
  RESET_BUY_AGAIN_DEALS: 'RESET_BUY_AGAIN_DEALS',
  SET_ALL_FEATURED_DEALS_LOADED: 'SET_ALL_FEATURED_DEALS_LOADED',
  SET_BUY_AGAIN_DEALS: 'SET_BUY_AGAIN_DEALS',
  SET_DEALS: 'SET_DEALS',
  SET_EXTRA_DEALS: 'SET_EXTRA_DEALS',
  SET_FOR_DEAL_PREVIEW: 'SET_FOR_DEAL_PREVIEW',
  SET_IS_DEAL_PREVIEW: 'SET_IS_DEAL_PREVIEW',
  SET_LAST_ID: 'SET_LAST_ID',
  SET_NEW_PRODUCT_DEALS: 'SET_NEW_PRODUCT_DEALS',
  SET_NO_MORE_DEALS: 'SET_NO_MORE_DEALS',
  SET_ONLY_MAIN_DEAL: 'SET_ONLY_MAIN_DEAL',
  SET_ONLY_SSR: 'SET_ONLY_SSR',
  SET_RECENTLY_VIEWED_DEALS: 'SET_RECENTLY_VIEWED_DEALS',
  SET_RECOMMENDED_DEALS: 'SET_RECOMMENDED_DEALS',
  SET_WITHOUT_MAIN_DEAL: 'SET_WITHOUT_MAIN_DEAL',
};

export const SCROLLER = { SET_SCROLLER: 'SET_SCROLLER' };

export const NAVIGATION = {
  SET_DEAL_PREVIEW: 'SET_DEAL_PREVIEW',
  SET_MENU: 'SET_MENU',
  SET_SSR: 'SET_NAVIGATION_SSR',
};

export const BASKET = {
  RESET_BASKET: 'RESET_BASKET',
  SET_BASKET: 'SET_BASKET',
};

export const CHECKOUT = {
  CHECKOUT_API_PARAMS: 'CHECKOUT_API_PARAMS',
  RESET_COUNTDOWN: 'CHECKOUT_RESET_COUNTDOWN',
  SET_CHECKOUT: 'SET_CHECKOUT',
  SET_CHECKOUT_STATUS: 'SET_CHECKOUT_STATUS',
  SET_COUNTDOWN: 'SET_COUNTDOWN',
  SET_TRAVEL: 'SET_TRAVEL',
  SET_TRAVEL_VALID: 'SET_TRAVEL_VALID',
};

export const WALLET = {
  ERROR_WALLET: 'ERROR_WALLET',
  RESET_WALLET: 'RESET_WALLET',
  SET_WALLET: 'SET_WALLET',
};

export const BCOR = {
  ERROR_BCOR: 'ERROR_BCOR',
  RESET_BCOR: 'RESET_BCOR',
  SET_CURRENT_DEAL_ID: 'SET_CURRENT_DEAL_ID',
  SET_FILTERED_PRODUCTS: 'SET_FILTERED_PRODUCTS',
  SET_NIGHT_OPTIONS: 'SET_NIGHT_OPTIONS',
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_QUANTITY: 'SET_QUANTITY',
  SET_SELECTED_NIGHTS: 'SET_SELECTED_NIGHTS',
  SET_SELECTION: 'SET_SELECTION',
};

export const FILTERS = {
  EMPTY_FILTERS: 'EMPTY_FILTERS',
  GET_FILTERS: 'GET_FILTERS',
  RESET_FILTERS: 'RESET_FILTERS',
  SET_EXTRA_FILTERS: 'SET_EXTRA_FILTERS',
  SET_FILTERS: 'SET_FILTERS',
  SET_NO_MORE_FILTERS: 'SET_NO_MORE_FILTERS',
  SET_URL_PATH: 'SET_URL_PATH',
};

export const GIFTING = {
  RESET_GIFTING: 'RESET_GIFTING',
  SET_GIFTING: 'SET_GIFTING',
  SET_NDD_GIFTING: 'SET_NDD_GIFTING',
  SET_STD_GIFTING: 'SET_STD_GIFTING',
};

export const VIDEO = {
  PLAY: 'VIDEO_PLAYING',
  SET_AUTO_PLAYABLE: 'SET_VIDEO_AUTO_PLAYABLE',
  SET_VISIBILITY: 'SET_VIDEO_VISIBILITY',
  STOP: 'VIDEO_STOP',
};

export const PAGE_TYPE = { SET_PAGE_TYPE: 'SET_PAGE_TYPE' };

export const WISHLIST = {
  RESET_WISHLIST: 'RESET_WISHLIST',
  SET_WISHLIST: 'SET_WISHLIST',
};

export const FOOTERS = {
  SET_FOOTER: 'SET_FOOTER',
};

export const TRACKING = {
  SET_TRACKING_DEALS: 'SET_TRACKING_DEALS',
};

// KEY PAYLOAD TYPES
// This is used to used to update the state of the key you wish to update
export const KEY_PAYLOAD_TYPES = {
  BUY_AGAIN_DEALS: 'buyAgainDeals',
  NEW_PRODUCT_DEALS: 'newProductDeals',
  RECENTLY_VIEWED_DEALS: 'recentlyViewedDeals',
  RECOMMENDED_DEALS: 'recommendedDeals',
};

export const GIFTS = {
  BY_INTEREST: 'Gifts By Interest',
  BY_OCCASION: 'Gifts By Occasion',
  BY_RECIPIENT: 'Gifts For Them',
  BY_RECIPIENT_FOR_TITLE: 'Gifts By Recipient',
  BY_TYPE: 'Gifts By Type',
  BY_VALENTINES: "Valentine's Day Gifts",
  VIEW_ALL_GIFTS: 'View All Gifts',
};
export const RECIPIENT = 'Recipient';
export const OCCASION = 'Occasion';
export const TYPE = 'Type';
export const INTEREST = 'Interest';
export const WOWCHER_LIMITED = 'Wowcher Limited';
